import { c as _c } from "react/compiler-runtime";
import Add from "@mui/icons-material/Add";
import Edit from "@mui/icons-material/Edit";
import FolderOpen from "@mui/icons-material/FolderOpen";
import { TabContext, TabList } from "@mui/lab";
import { IconButton, Stack, Tab, Tooltip } from "@mui/material";
import Head from "next/head";
import React, { useState } from "react";
import { ArgsEditor } from "#/features/argsEditor/ui/ArgsEditor";
import { useProjectPanelData } from "#/features/project/hooks/useProjectPanelData";
import { useProjectBrowserContext } from "#/features/project/ui/ProjectBrowser/ProjectBrowserContext";
import { TestCaseSelectBar } from "#/features/project/ui/TestCaseSelectBar";
import { useI18nContext } from "#/shared/hooks";
import { LoadingSkeletonOverlay } from "#/shared/ui/atoms/LoadingSkeletonOverlay";
import { PanelWrapper } from "#/shared/ui/templates/PanelWrapper";
import { StyledTabPanel } from "#/shared/ui/templates/StyledTabPanel";
import { TabListWrapper } from "#/shared/ui/templates/TabListWrapper";
import { ProjectInfo } from "./ProjectInfo";
import { ProjectModal } from "./ProjectModal";
export const ProjectPanel: React.FC = () => {
  const $ = _c(61);
  const {
    LL
  } = useI18nContext();
  const {
    session,
    isEditable,
    selectedProject,
    selectedCase
  } = useProjectPanelData();
  const {
    openBrowser
  } = useProjectBrowserContext();
  const [tabValue, setTabValue] = useState("1");
  const [isProjectModalOpen, setIsProjectModalOpen] = useState(false);
  const [isModalEditMode, setIsModalEditMode] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = (_, newValue) => {
      setTabValue(newValue);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const handleTabChange = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setIsModalEditMode(false);
      setIsProjectModalOpen(true);
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleCreateProject = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setIsModalEditMode(true);
      setIsProjectModalOpen(true);
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const handleEditProject = t2;
  const t3 = selectedProject.data ? `${selectedProject.data?.title} - dStruct Playground` : "dStruct Playground";
  let t4;
  if ($[3] !== t3) {
    t4 = <Head><title>{t3}</title></Head>;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => setIsProjectModalOpen(false);
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== isModalEditMode || $[7] !== isProjectModalOpen || $[8] !== selectedProject.data) {
    t6 = <ProjectModal open={isProjectModalOpen} onClose={t5} isEditMode={isModalEditMode} currentProject={selectedProject.data} />;
    $[6] = isModalEditMode;
    $[7] = isProjectModalOpen;
    $[8] = selectedProject.data;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <LoadingSkeletonOverlay />;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== LL) {
    t8 = LL.PANEL_TABS();
    $[11] = LL;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== LL) {
    t9 = LL.PROJECT();
    $[13] = LL;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t9) {
    t10 = <Tab label={t9} value="1" />;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t10 || $[18] !== t8) {
    t11 = <TabList onChange={handleTabChange} aria-label={t8}>{t10}</TabList>;
    $[17] = t10;
    $[18] = t8;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      alignItems: "center",
      pr: 1
    };
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== LL) {
    t13 = LL.PROJECT_BROWSER();
    $[21] = LL;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  const t14 = `${t13} 📁`;
  let t15;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <FolderOpen />;
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  let t16;
  if ($[24] !== openBrowser) {
    t16 = <IconButton onClick={openBrowser}>{t15}</IconButton>;
    $[24] = openBrowser;
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  let t17;
  if ($[26] !== t14 || $[27] !== t16) {
    t17 = <Tooltip title={t14} arrow={true}>{t16}</Tooltip>;
    $[26] = t14;
    $[27] = t16;
    $[28] = t17;
  } else {
    t17 = $[28];
  }
  let t18;
  if ($[29] !== LL || $[30] !== isEditable) {
    t18 = isEditable && <Tooltip title={`${LL.EDIT_SELECTED_PROJECT()} ✍`} arrow={true}><IconButton onClick={handleEditProject}><Edit /></IconButton></Tooltip>;
    $[29] = LL;
    $[30] = isEditable;
    $[31] = t18;
  } else {
    t18 = $[31];
  }
  let t19;
  if ($[32] !== LL || $[33] !== session.data) {
    t19 = session.data && <Tooltip title={`${LL.CREATE_NEW_PROJECT()} ➕`} arrow={true}><IconButton onClick={handleCreateProject}><Add /></IconButton></Tooltip>;
    $[32] = LL;
    $[33] = session.data;
    $[34] = t19;
  } else {
    t19 = $[34];
  }
  let t20;
  if ($[35] !== t17 || $[36] !== t18 || $[37] !== t19) {
    t20 = <Stack direction="row" spacing={1} sx={t12}>{t17}{t18}{t19}</Stack>;
    $[35] = t17;
    $[36] = t18;
    $[37] = t19;
    $[38] = t20;
  } else {
    t20 = $[38];
  }
  let t21;
  if ($[39] !== t11 || $[40] !== t20) {
    t21 = <TabListWrapper>{t11}{t20}</TabListWrapper>;
    $[39] = t11;
    $[40] = t20;
    $[41] = t21;
  } else {
    t21 = $[41];
  }
  let t22;
  if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = {
      display: "flex",
      flexFlow: "column nowrap",
      p: 2,
      gap: 1
    };
    $[42] = t22;
  } else {
    t22 = $[42];
  }
  let t23;
  if ($[43] !== selectedProject.data) {
    t23 = <ProjectInfo project={selectedProject.data} />;
    $[43] = selectedProject.data;
    $[44] = t23;
  } else {
    t23 = $[44];
  }
  let t24;
  if ($[45] !== selectedProject) {
    t24 = <TestCaseSelectBar selectedProject={selectedProject} />;
    $[45] = selectedProject;
    $[46] = t24;
  } else {
    t24 = $[46];
  }
  let t25;
  if ($[47] !== selectedCase) {
    t25 = <ArgsEditor selectedCase={selectedCase} />;
    $[47] = selectedCase;
    $[48] = t25;
  } else {
    t25 = $[48];
  }
  let t26;
  if ($[49] !== t23 || $[50] !== t24 || $[51] !== t25) {
    t26 = <StyledTabPanel value="1" sx={t22}>{t23}{t24}{t25}</StyledTabPanel>;
    $[49] = t23;
    $[50] = t24;
    $[51] = t25;
    $[52] = t26;
  } else {
    t26 = $[52];
  }
  let t27;
  if ($[53] !== t21 || $[54] !== t26 || $[55] !== tabValue) {
    t27 = <TabContext value={tabValue}>{t21}{t26}</TabContext>;
    $[53] = t21;
    $[54] = t26;
    $[55] = tabValue;
    $[56] = t27;
  } else {
    t27 = $[56];
  }
  let t28;
  if ($[57] !== t27 || $[58] !== t4 || $[59] !== t6) {
    t28 = <PanelWrapper>{t4}{t6}{t7}{t27}</PanelWrapper>;
    $[57] = t27;
    $[58] = t4;
    $[59] = t6;
    $[60] = t28;
  } else {
    t28 = $[60];
  }
  return t28;
};